<button
  mat-icon-button color="primary"
  (click)="toggleAll()"
  [tmTooltip]="toggleAllLayersTooltip$ | async">
  @if (someLayersVisible$ | async) {
    <mat-icon svgIcon="uncheck_all"></mat-icon>
  } @else {
    <mat-icon svgIcon="check_all"></mat-icon>
  }
</button>
